import { getOS, OS } from 'utils/DetectOS'

function makeCmdEnterHandler(callback){
  return (event) => {
    if (event.key === 'Enter' && ((getOS() === OS.MAC && event.metaKey) || event.ctrlKey)) {
      event.preventDefault()
      callback()
    }
  }
}

export default makeCmdEnterHandler



// WEBPACK FOOTER //
// ./src/scripts/components/customer/Inputs/makeCmdEnterHandler.js